import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { Section, Title } from '../styled/StyledComponents';
import { contentVariants } from '../animations/Variants';

const TableContainer = styled.div`
  margin: 8rem auto;
  max-width: 800px;
  padding: 0;
  width: 90%;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
`;

const Th = styled.th`
  background-color: #2c3e50;
  color: white;
  padding: 1rem;
  text-align: left;
  font-weight: 600;
`;

const Td = styled.td`
  padding: 1rem;
  border-bottom: 1px solid #eee;
  
  &:last-child {
    color: #666;
  }
`;

const Tr = styled.tr`
  &:hover {
    background-color: #f8f9fa;
  }
  
  &:last-child td {
    border-bottom: none;
  }
`;

const Link = styled.a`
  color: #3498db;
  text-decoration: none;
  transition: color 0.2s;
  
  &:hover {
    color: #2980b9;
    text-decoration: underline;
  }
`;

const LiensSection: React.FC = () => {
  const liens = [
    {
      nom: "Association Genevoise des Psychomotriciens (AGP)",
      url: "https://psychomotricite-ge.ch",
      description: "Association professionnelle des psychomotriciens à Genève"
    },
    {
      nom: "HUG - Unité de Psychomotricité",
      url: "https://www.hug.ch/psychiatrie-developpement-mental/unite-psychomotricite",
      description: "Service de psychomotricité des Hôpitaux Universitaires de Genève"
    },
    {
      nom: "HETS Genève - Formation Psychomotricité",
      url: "https://www.hesge.ch/hets/formation-base/bachelor/psychomotricite",
      description: "Formation en psychomotricité à la Haute école de travail social"
    },
    {
      nom: "Office Médico-Pédagogique (OMP)",
      url: "https://www.ge.ch/organisation/office-medico-pedagogique-omp",
      description: "Services thérapeutiques pour enfants et adolescents"
    },
    {
      nom: "Cap Loisirs - Activités Psychomotrices",
      url: "https://www.caploisirs.ch",
      description: "Activités adaptées et psychomotricité pour enfants"
    }
  ];

  return (
    <motion.div
      key="liens"
      initial="enter"
      animate="center"
      exit="exit"
      variants={contentVariants}
    >
      <Section>
        <Title>Liens Utiles</Title>
        <TableContainer>
          <Table>
            <thead>
              <tr>
                <Th>Organisation</Th>
                <Th>Description</Th>
              </tr>
            </thead>
            <tbody>
              {liens.map((lien, index) => (
                <Tr key={index}>
                  <Td>
                    <Link href={lien.url} target="_blank" rel="noopener noreferrer">
                      {lien.nom}
                    </Link>
                  </Td>
                  <Td>{lien.description}</Td>
                </Tr>
              ))}
            </tbody>
          </Table>
        </TableContainer>
      </Section>
    </motion.div>
  );
};

export default LiensSection;
